import { io } from 'jsts';
import { squareMeterToHectare } from './MathUtils';

const joinCoords = (coordinates): any => {
  const coordinatesAfterPrecisionReduction = coordinates.map((point) =>
    point.map(value => parseFloat(value.toFixed(14))),
  );

  // in WKT the last point must be the first point
  if (coordinatesAfterPrecisionReduction[coordinatesAfterPrecisionReduction.length - 1] !== coordinatesAfterPrecisionReduction[0]) {
    coordinatesAfterPrecisionReduction.push(coordinatesAfterPrecisionReduction[0]);
  }

  return coordinatesAfterPrecisionReduction.map(point => point.join(' ')).join(',');
};

const transformPolygonCoordsToWKT = (coordinates): string => {
  return `POLYGON ((${joinCoords(coordinates)}))`;
};

const checkIfAPolygonIsSimple = (coordinates): boolean => {
  const wktReader = new io.WKTReader();

  const polygonCoordsToWKT = transformPolygonCoordsToWKT(coordinates);
  const polygonGeometry = wktReader.read(polygonCoordsToWKT);

  return polygonGeometry.isSimple();
};

const convertToRadian = (input): number => {
  return input * Math.PI / 180;
};

const calculatePolygonAreaInHectare = (coordinates): number | null => {
  if (coordinates.length >= 4
    && (coordinates[coordinates.length - 1].lat == coordinates[0].lat)
    && (coordinates[coordinates.length - 1].lon == coordinates[0].lon)
  ) {
    let area = 0;

    for (let iCount = 0; iCount < coordinates.length - 1; iCount++) {
      let p1 = coordinates[iCount];
      let p2 = coordinates[iCount + 1];

      area += convertToRadian(p2.lon - p1.lon) *
        (2 +
          Math.sin(convertToRadian(p1.lat)) +
          Math.sin(convertToRadian(p2.lat)));
    }

    const largerSemiAxle = 6378137;
    area = area * largerSemiAxle * largerSemiAxle / 2;

    return squareMeterToHectare(Math.abs(area));
  } else {
    return null;
  }
};

export {
  calculatePolygonAreaInHectare,
  convertToRadian,
  checkIfAPolygonIsSimple,
};
